import { createSelector } from "reselect";
import { makeSelectAllQuestions } from "../questions/selectors";
import { makeSelectStringSource } from "../stringResources/selectors";
import { makeSelectTranslation } from "../translation/selectors";
import { makeSelectLanguages } from "../languages";
import { makeSelectCriteria } from "../alg_criteria/selectors";
import { makeSelectVideo } from "../videos";

const selectEntity = state => state.entities.questionnaire_category;
const selectEntityData = state =>
  state.entities.questionnaire_category
    ? state.entities.questionnaire_category.data
    : {};
const selectCategoryQuestion = state =>
  state.entities.questionnaire_category_question
    ? state.entities.questionnaire_category_question.data
    : {};
const selectCategoryQuestionCriteria = state =>
  state.entities.questionnaire_category_question_criteria
    ? state.entities.questionnaire_category_question_criteria.data
    : {};
const selectCategoryQuestionAnswerOptionAlgValue = state =>
  state.entities.questionnaire_category_question_answer_option_alg_value
    ? state.entities.questionnaire_category_question_answer_option_alg_value
        .data
    : {};

export const makeSelectQuestionnaireCategory = () =>
  createSelector(
    [
      selectEntityData,
      selectCategoryQuestion,
      selectCategoryQuestionCriteria,
      makeSelectAllQuestions(),
      makeSelectStringSource(),
      makeSelectTranslation(),
      makeSelectLanguages(),
      makeSelectCriteria(),
      selectCategoryQuestionAnswerOptionAlgValue,
      makeSelectVideo()
    ],
    (
      substate,
      categoryQuestions,
      questionCriteria,
      questions,
      resources,
      translations,
      languages,
      algCriteria,
      optionAlgValue,
      videos
    ) => {
      optionAlgValue = Object.keys(optionAlgValue).map(
        option => optionAlgValue[option]
      );

      const result = {};
      for (let key in substate) {
        const category = { ...substate[key] };
        const questionsList = [];
        if (category.questions) {
          for (let categoryQuestion of category.questions) {
            const criteriaList = [];

            let criteria =
              categoryQuestions[categoryQuestion.id].question_criteria &&
              categoryQuestions[categoryQuestion.id].question_criteria.length >
                0
                ? categoryQuestions[categoryQuestion.id].question_criteria
                : [];

            criteria.map(c =>
              criteriaList.push(algCriteria[questionCriteria[c.id].criteria_id])
            );
            criteria = criteriaList;
            const question =
              questions[categoryQuestions[categoryQuestion.id].question.id];
            question.index = categoryQuestions[categoryQuestion.id].index;
            questionsList.push({
              question,
              criteria: criteria,
              categoryQuestionId: categoryQuestions[categoryQuestion.id].id,
              categoryId:
                categoryQuestions[categoryQuestion.id]
                  .questionnaire_category_id,
              is_required: categoryQuestions[categoryQuestion.id].required
            });
          }
        }
        if (questionsList.length > 0) {
          const newQuestions = [];
          for (let question of questionsList) {
            question.question["criteria"] = question.criteria;
            question.question["categoryQuestionId"] =
              question.categoryQuestionId;
            question.question["categoryId"] = question.categoryId;
            question.question["questionnaireId"] = category.questionnaire_id;
            question.question["is_required"] = question.is_required;
            delete question.criteria;
            delete question.categoryQuestionId;

            for (let answer of question.question.answers) {
              for (let video of videos) {
                if (answer.video_id === video.id) answer.video = video;
              }
              for (let answerValue of optionAlgValue) {
                if (
                  answer.id === answerValue.answer_option_id &&
                  answerValue.questionnaire_category_question_id ===
                    question.question.categoryQuestionId
                ) {
                  answer["value"] = answerValue.value;
                  answer["optionAlgValueId"] = answerValue.id;
                  /*
              newAnswers.push({
                ...answer, ['value']: answerValue.value,
                ['optionAlgValueId']: answerValue.id
              })*/
                }
              }
            }

            //question.question.answers = newAnswers;
            newQuestions.push(question.question);
          }
          category.questions = newQuestions;
        }

        for (let resource of resources) {
          if (resource.id === category.string_resources.id) {
            category.string_resources = resource;
          }
        }

        const newTranslations = [];

        if (
          category.string_resources &&
          category.string_resources.translations
        ) {
          for (let translation of category.string_resources.translations) {
            newTranslations.push(translations[translation.id]);
          }
          category.string_resources.translations = newTranslations;

          for (let languageCategory of category.string_resources.translations) {
            for (let language of languages) {
              if (languageCategory.language_id === language.id)
                languageCategory.language = language;
            }
          }
          const stringValues = {};
          for (let translation of category.string_resources.translations) {
            stringValues[translation.language.id] = translation.translation;
          }
          category["initialValues"] = {
            languages: stringValues,
            principle: category.principle ? category.principle.id : null
          };
        }

        result[key] = category;
      }

      return result;
    }
  );

export const makeSelectIsQuestionnaireCategoryLoading = () =>
  createSelector(selectEntity, substate => {
    if (substate) return substate.loading;
  });

export const makeSelectIsQuestionnaireCategoryError = () =>
  createSelector(selectEntity, substate => {
    if (substate) return substate.error;
  });
